<template>
  <div>
    <px-view-header title="Editar cotação" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>

    <div v-if="loading">
      <px-circular-loading/>
    </div>

    <div v-if="!loading && cotacao">
      <px-cadastro-cotacao-frete-carga is-editing
                                       btn-label="Salvar"
                                       :cotacao="cotacao"
                                       :is-comprador="isComprador"
                                       @next="save"/>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { onlyNumbers } from '@/utils/regex-utils';
import { NumberUtils } from 'px-components';
import CadastroCotacaoFreteCarga from '../cadastro/CadastroCotacaoFreteCarga.vue';
import CotacaoFreteService from '../cotacao-frete-service';

export default {
  data() {
    return {
      id: this.$route.params.id,
      currentStep: 1,
      type: this.$route.query.type,
      cotacao: null,
      loading: false,
      loadingForm: false,
      breadcrumbs: [
        { text: 'Gestão de frete' },
        {
          text: 'Cotações de frete',
          to: '/cotacoes-fretes',
        },
        { text: 'Cadastro de cotação' },
      ],
    };
  },
  computed: {
    isComprador() {
      return this.$pxFrete.isComprador;
    },
  },
  methods: {
    onClickBack() {
      this.$router.push({
        name: 'main.gestao-frete.cotacoes.detalhes',
        params: {
          id: this.id,
        },
      });
    },
    buildPayload() {
      const cotacao = cloneDeep(this.cotacao);
      cotacao.cepColeta = onlyNumbers(cotacao.cepColeta);
      cotacao.cepEntrega = onlyNumbers(cotacao.cepEntrega);
      cotacao.transportadoras = undefined;
      cotacao.cpfCnpjColeta = onlyNumbers(cotacao.cpfCnpjColeta);
      cotacao.cpfCnpjEntrega = onlyNumbers(cotacao.cpfCnpjEntrega);
      return cotacao;
    },
    save() {
      this.loadingForm = true;
      CotacaoFreteService.update(this.cotacao.id, this.buildPayload())
        .then(() => {
          this.$toast('Cotação atualizada', { color: 'success' });
          this.onClickBack();
        })
        .finally(() => {
          this.loadingForm = false;
        });
    },
    setupEditing(cotacao) { /* eslint-disable no-param-reassign */
      cotacao.valorMercadoria = NumberUtils.fixNumberInput(cotacao.valorMercadoria);
      cotacao.volumes.forEach((v) => {
        v.largura = NumberUtils.fixNumberInput(v.largura);
        v.comprimento = NumberUtils.fixNumberInput(v.comprimento);
        v.altura = NumberUtils.fixNumberInput(v.altura);
      });
    },
    getCotacao() {
      this.loading = true;
      CotacaoFreteService.getCotacao(this.id)
        .then(({ data }) => {
          this.setupEditing(data);
          this.cotacao = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getCotacao();
  },
  components: {
    pxCadastroCotacaoFreteCarga: CadastroCotacaoFreteCarga,
  },
};
</script>
